






























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import Icon from "../../Icon/Icon.vue";
import { RawFrontendChipItem } from "../typedChips.types";

@Component({
  components: {
    Icon
  }
})
export default class ChipsList extends Vue {
  @Prop() chips!: Array<RawFrontendChipItem>

  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean

  @Emit()
  onSelectChip(item: RawFrontendChipItem) {
    return item
  }

  @Emit()
  onTagRemove(guid: RawFrontendChipItem['guid']) {
    return guid
  }

  first12Symbols(value: string) {
    if (value.length > 15) {
      return `${ value.slice(0, 12) }...`
    }

    return value
  }
}
